import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import { replaceVariables } from 'PDF/TemplateEngine/utils/replaceVariables';

function TextSection({ section, data }) {
  const { colors, baseStyles, FONT } = useTemplateColors();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        container: {
          display: 'flex',
          flexDirection: 'column',
        },
        body: {
          fontSize: 10,
          fontFamily: FONT.base,
          color: colors.bodyText,
          lineHeight: 1.4,
          textAlign: 'justify',
        },
      }),
    [colors, FONT]
  );

  const body = replaceVariables(section?.config?.body, data);

  return (
    // I5 (review 2026-07-13): sin `wrap={false}` — una cláusula legal más
    // larga que el espacio restante en la página (garantías del catálogo
    // pueden ser varios párrafos) se corta en silencio en vez de saltar de
    // página. Texto legal truncado es el peor modo de falla posible.
    <View style={styles.container}>
      {section?.title ? <Text style={baseStyles.sectionTitle}>{section.title}</Text> : null}
      <Text style={styles.body}>{body || '—'}</Text>
    </View>
  );
}

export default TextSection;
